"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdowns = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const molecule_1 = require("./molecule");
const props_1 = require("../common/props");
/**
 * The dropdowns molecule.
 * @category Molecules
 */
class Dropdowns extends molecule_1.Molecule {
    constructor(molecules) {
        super("Dropdowns", molecules);
        this.menuFocusState = new props_1.PropertyStringSelectable("Dropdown Menu Focus State", true, this, {
            selectables: [Dropdowns.LEFT_BORDER_ONLY, Dropdowns.FULL_COLOR],
            defaultValue: Dropdowns.LEFT_BORDER_ONLY,
        });
        this.menuShadow = new props_1.PropertyShadowSelectable("Open Dropdown Menu Shadow", true, this, { defaultValue: "Elevation 1" });
        this.borderRadius = new props_1.PropertyNumberSelectable("Dropdown Border Radius", true, this, [0, 0.5, 1, 2], 1);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.menuFocusState.deserialize(obj.menuFocusState);
        this.borderRadius.deserialize(obj.borderRadius);
        this.menuShadow.deserialize(obj.menuShadow);
    }
    serialize() {
        const obj = {};
        obj.menuFocusState = this.menuFocusState.serialize();
        obj.borderRadius = this.borderRadius.serialize();
        obj.menuShadow = this.menuShadow.serialize();
        return obj;
    }
}
exports.Dropdowns = Dropdowns;
Dropdowns.FULL_COLOR = "Full Color";
Dropdowns.LEFT_BORDER_ONLY = "Left border only";
